import { render, staticRenderFns } from "./HeaderFlag.vue?vue&type=template&id=6f4a1664&scoped=true&"
import script from "./HeaderFlag.vue?vue&type=script&lang=js&"
export * from "./HeaderFlag.vue?vue&type=script&lang=js&"
import style1 from "./HeaderFlag.vue?vue&type=style&index=1&id=6f4a1664&lang=scss&"
import style2 from "./HeaderFlag.vue?vue&type=style&index=2&id=6f4a1664&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4a1664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4a1664')) {
      api.createRecord('6f4a1664', component.options)
    } else {
      api.reload('6f4a1664', component.options)
    }
    module.hot.accept("./HeaderFlag.vue?vue&type=template&id=6f4a1664&scoped=true&", function () {
      api.rerender('6f4a1664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fimalac/components/HeaderFimalac/HeaderFlag.vue"
export default component.exports